import { useState } from "react";
import instance from "../Api/Instance";
import { back } from "../Api/ApiUrl";
import { togglePaginating } from "../utils/setterUtils";

const getError = (error, actionType) => {
  const actionValues = {
    update: "actualizar",
    delete: "borrar",
  };

  if (error?.response && error?.response?.data) {
    return error.response.data;
  }

  return {
    apierror: {
      status: "ERROR",
      message: `Error al ${actionValues?.[actionType]} remitente.`,
    },
  };
};

export default function useSenders() {
  const [sendersDetails, setSendersDetails] = useState({
    isLoading: false,
    isPaginating: false,
    page: 1,
    size: 10,
    total: 0,
    data: [],
    errors: [],
    searchWasMade: false,
  });

  const getSenders = async (senderName) => {
    try {
      const response = await instance.get(back.getParticipants, {
        params: {
          participantName: senderName,
          participantType: 1,
        },
      });

      if (response.status === 200) {
        const data = response?.data?.slice(0, 10);
        return data;
      }

      setSendersDetails((prevState) => ({
        ...prevState,
        isLoading: false,
        data: [],
      }));

      return [];
    } catch (error) {
      console.error("Error al solicitar remitentes => " + error?.message);
    }
  };

  const getPagedSenders = async (
    page = 1,
    size = 10,
    participantName,
    paginating = false
  ) => {
    try {
      setSendersDetails((prevState) => ({
        ...prevState,
        isLoading: !paginating,
        isPaginating: paginating,
        page: page,
        size: size,
        participantName: participantName,
        data: paginating ? prevState.data : [],
        errors: [],
        searchWasMade: paginating ? true : false,
      }));
      const response = await instance.get(back.getPagedParticipants, {
        params: {
          page: page - 1,
          participantName: participantName,
          size: size,
          participantType: 1,
        },
      });

      if (response.status === 200) {
        setSendersDetails((prevState) => ({
          ...prevState,
          isLoading: false,
          isPaginating: false,
          page: page,
          size: size,
          participantName: participantName,
          total: response?.data?.totalElements,
          data: response?.data?.content,
          errors: [],
          searchWasMade: true,
        }));

        // return true;
        return response?.data?.content;
      }

      setSendersDetails((prevState) => ({
        ...prevState,
        isLoading: false,
        isPaginating: false,
        page: page,
        size: size,
        participantName: participantName,
        total: 0,
        data: [],
        searchWasMade: true,
      }));
      // return false;
      return [];
    } catch (error) {
      console.error(error);
      setSendersDetails({
        isLoading: false,
        isPaginating: false,
        page: page,
        size: size,
        participantName: participantName,
        total: 0,
        data: [],
        error: error,
        searchWasMade: true,
      });
      throw new Error(`Al solicitar remitentes => ${error?.message}`);
    }
  };

  const addSender = async (senderDetails, mustRefetch = true) => {
    try {
      const response = await instance.post(back.addParticipant, senderDetails, {
        params: { participantType: 1 },
      });

      if (response.status === 201 && mustRefetch) {
        await getPagedSenders(
          sendersDetails.page,
          sendersDetails.size,
          sendersDetails.participantName ?? null,
          true
        );
        return { status: "ok", data: response?.data };
      }

      if (response.status === 201 && !mustRefetch) {
        return { status: "ok", data: response?.data };
      }

      return {
        status: "error",
        error: "Se ha producido un error al guardar el remitente.",
      };
    } catch (error) {
      console.error(error);
      return {
        status: "error",
        error: `Se ha producido el siguiente error al guardar el remitente: ${error?.message} `,
      };
    }
  };

  const updateSender = async (updatedSenderDetails) => {
    togglePaginating(setSendersDetails, true);
    try {
      const response = await instance.put(
        `${back.updateParticipant}/${updatedSenderDetails?.participantId}`,
        updatedSenderDetails
      );

      if (response.status === 204) {
        setSendersDetails((prevState) => ({
          ...prevState,
          isPaginating: false,
          data: prevState.data.map((item) =>
            item?.participantId === updatedSenderDetails?.participantId
              ? { ...item, ...updatedSenderDetails }
              : item
          ),
        }));

        return true;
      }

      togglePaginating(setSendersDetails, false);
      return false;
    } catch (error) {
      console.error(error);
      togglePaginating(setSendersDetails, false);
      getError(error, "update");
    }
  };

  const deleteSender = async (senderId) => {
    togglePaginating(setSendersDetails, true);
    try {
      const response = await instance.delete(
        `${back.deleteParticipant}/${senderId}`
      );

      if (response.status === 204) {
        const newParticipants = JSON.parse(
          JSON.stringify(sendersDetails?.data)
        );
        setSendersDetails((prevState) => ({
          ...prevState,
          isPaginating: false,
          data: newParticipants.filter(
            (item) => item.participantId !== senderId
          ),
        }));
        return true;
      }

      togglePaginating(setSendersDetails, false);
      return false;
    } catch (error) {
      console.error(error);
      togglePaginating(setSendersDetails, false);
      getError(error, "delete");
    }
  };

  return {
    setSendersDetails,
    sendersDetails,
    addSender,
    getSenders,
    getPagedSenders,
    updateSender,
    deleteSender,
  };
}
